import { render, staticRenderFns } from "./ConsumerMessages.vue?vue&type=template&id=64274a7d"
import script from "./ConsumerMessages.vue?vue&type=script&lang=js"
export * from "./ConsumerMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports